import { Route, Routes } from 'react-router'

import { NotFound } from 'js/core/NotFound'
import Add from 'js/magazine-issue/AddEdit/Add/Add'
import Edit from 'js/magazine-issue/AddEdit/Edit/Edit'
import AddArticle from 'js/magazine-issue/AddEditArticle/Add/Add'
import EditArticle from 'js/magazine-issue/AddEditArticle/Edit/Edit'
import View from 'js/magazine-issue/View'
import {
    ArticlePageRoute,
    ColophonPageRoute,
    CoverPageRoute,
} from 'js/magazine-issue/View/ViewRoutes'

const MagazineIssueRoutes = () => (
    <Routes>
        {/* Issue */}
        <Route path="add/:containerGuid" element={<Add />} />
        <Route path="edit/:guid" element={<Edit />} />

        {/* Article */}
        <Route
            path="view/:containerGuid/add-article"
            element={<AddArticle />}
        />
        <Route path="edit/:containerGuid/:guid" element={<EditArticle />} />

        {/* View magazine issue */}
        <Route path="view/:containerGuid" element={<View />}>
            <Route path=":slug" element={<CoverPageRoute />} />
            <Route path=":slug/colophon" element={<ColophonPageRoute />} />
            <Route path=":guid/:slug" element={<ArticlePageRoute />} />
        </Route>

        <Route path="*" element={<NotFound />} />
    </Routes>
)

export default MagazineIssueRoutes
